module.exports = __webpack_public_path__ + "images/feature/popup-sxh@2x-cd7d5abbd84829a85792c66c22ea8046.png";